import { Observable } from 'rxjs';

import { Injectable } from '@angular/core';
import { DataList, FaqsCategory, Faqs } from '@shared/models';

import { ApiService } from '../api/api.service';

@Injectable({
  providedIn: 'root',
})
export class FaqsService {
  constructor(private apiService: ApiService) {}

  categories(parent_id: number | string): Observable<DataList<FaqsCategory>> {
    return this.apiService.get<DataList<FaqsCategory>>('user/faq_categories?parent_id=' + parent_id).pipe();
  }

  faqs(id: number | string): Observable<DataList<Faqs>> {
    return this.apiService.get<DataList<Faqs>>('user/faqs?faq_category_id=' + id).pipe();
  }
}
